import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

const ModalContent = styled.div`
    background: white;
    padding: 20px;
    border-radius: 5px;
    max-width: 500px;
    width: 100%;
    text-align: center;
    white-space: pre-line; /* Adicionado para respeitar quebras de linha */
`;

const ModalButton = styled.button`
    margin-top: 20px;
    padding: 10px 20px;
    background-color: rgb(0, 107, 219);
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
`;

interface ModalProps {
    message: string;
    onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ message, onClose }) => {
    return (
        <ModalOverlay>
            <ModalContent>
                <p>{message}</p>
                <ModalButton onClick={onClose}>OK</ModalButton>
            </ModalContent>
        </ModalOverlay>
    );
};

export default Modal;
